export default __webpack_public_path__ + "static/media/service_point_color.b8ac8268.svg";